<template>
  <div>
    <section class="d-flex align-items-center h-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 bg-body py-3" id="gradientPicture">
            <div class="text-center mb-4">
              <img src="@/assets/logo-form.svg" class="img-fluid img-logo" width="70px" height="70px"
                   alt="Colorffy logo">
            </div>
            <div class="card">
              <div class="card-header mt-2">
                <div class="text-center mb-2">
                  <p class="subtitle-1 fw-500 mdc-18">{{ gradient.name }}</p>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center badge badge-default-outline px-3">
                    <i class="material-icons me-2" :style="{'color' : gradient.color1}">circle</i>
                    <p class="subtitle-1 text-uppercase mb-0">{{ gradient.color1 }}</p>
                  </div>
                  <div class="d-flex align-items-center badge badge-default-outline px-3">
                    <i class="material-icons me-2" :style="{'color' : gradient.color2}">circle</i>
                    <p class="subtitle-1 text-uppercase mb-0">{{ gradient.color2 }}</p>
                  </div>
                  <div class="d-flex align-items-center badge badge-default-outline px-3" v-if="gradient.color3">
                    <i class="material-icons me-2" :style="{'color' : gradient.color3}">circle</i>
                    <p class="subtitle-1 text-uppercase mb-0">{{ gradient.color3 }}</p>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="gradient gradient-generator" v-if="gradient.color3"
                     :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }"></div>
                <div class="gradient gradient-generator" v-else
                     :style="{ 'background': 'linear-gradient' + '(to right,' + gradient.color1 + ',' + gradient.color2 + ')' }"></div>
              </div>
              <div class="card-footer text-center no-border">
                <p class="subtitle-1 text-primary fw-500 mb-2">colorffy.com</p>
              </div>
            </div>
          </div>

          <!-- DOWNLOAD BUTTON -->
          <button class="btn btn-fab m-0" @click="downloadGradient"><i
              class="material-icons-outlined btn-fab-icon">download</i>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import * as htmlToImage from 'html-to-image';

export default {
  name: 'GradientPicture',
  metaInfo() {
    return {
      title: this.gradient.name + ' | Gradient',
    }
  },
  data() {
    return {
      gradient: {}
    }
  },
  mounted() {
    this.getGradient()
  },
  methods: {
    async getGradient() {
      const db = firebase.firestore()
      const gradient = await db.collection('gradients').doc(this.$route.params.gradientId).get()
      this.gradient = {id: gradient.id, ...gradient.data()}
    },
    downloadGradient() {
      htmlToImage.toJpeg(document.getElementById('gradientPicture'), {quality: 1})
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = 'gradient-picture.jpeg';
            link.href = dataUrl
            link.click();
          })
    },
  }
}
</script>